import { Component, Emit, Prop, Provide, Ref, Vue } from 'vue-property-decorator'
import ConfigurationLocalAssaysAssaysLaboratoryModalBasicForm
    from '@/modules/configurationModule/detail/local-assays/assays-laboratory/components/modal-basic-form/configuration-local-assays-assays-laboratory-modal-basic-form.vue'
import { BModal } from 'bootstrap-vue'
import {
    ConfigurationAssayLaboratoryCreateRequest,
    ConfigurationAssayLaboratoryPatchInBatchRequest,
    ConfigurationAssayLaboratoryResponse
} from '@/modules/configurationModule/detail/local-assays/assays-laboratory/services/configuration-assay-laboratory/configuration-assay-laboratory.dto'
import {
    ConfigurationLocalAssaysAssaysLaboratoryModalState,
    initialConfigurationLocalAssaysAssaysLaboratoryModalState
} from '@/modules/configurationModule/detail/local-assays/assays-laboratory/components/modal/configuration-local-assays-assays-laboratory-modal.model'

@Component({
    components: {
        ConfigurationLocalAssaysAssaysLaboratoryModalBasicForm
    }
})
export default class ConfigurationLocalAssaysAssaysLaboratoryModal extends Vue {
    @Ref() readonly assaysLaboratoryModal!: BModal

    @Prop(String) readonly actionTitle!: string

    @Provide() externalValidator = this.$validator

    @Emit()
    create(): ConfigurationAssayLaboratoryCreateRequest {
        return {
            assayId: this.state.assayLaboratory.assay!.id,
            active: !!this.state.assayLaboratory.active,
            accreditation: !!this.state.assayLaboratory.accreditation,
            visibilityReport: !!this.state.assayLaboratory.visibilityReport,
            localCatalog: !!this.state.assayLaboratory.localCatalog
        }
    }

    @Emit()
    update(): ConfigurationAssayLaboratoryPatchInBatchRequest {
        return {
            id: this.state.assayLaboratory.id!,
            active: !!this.state.assayLaboratory.active,
            accreditation: !!this.state.assayLaboratory.accreditation,
            visibilityReport: !!this.state.assayLaboratory.visibilityReport,
            localCatalog: !!this.state.assayLaboratory.localCatalog
        }
    }

    state: ConfigurationLocalAssaysAssaysLaboratoryModalState

    private get _updateMode(): boolean {
        return !!this.state.assayLaboratory?.id
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.$validator.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        return !hasErrors && isDirty
    }

    constructor() {
        super()
        this.state = initialConfigurationLocalAssaysAssaysLaboratoryModalState()
    }

    async show(assayLaboratory?: ConfigurationAssayLaboratoryResponse): Promise<void> {
        await this.$validator.reset()

        this.state = initialConfigurationLocalAssaysAssaysLaboratoryModalState()
        if (assayLaboratory) {
            this.state.assayLaboratory = { ...assayLaboratory }
        }

        this.assaysLaboratoryModal.show()
    }

    hide(): void {
        this.assaysLaboratoryModal.hide()
    }

    async doAction(): Promise<void> {
        const valid = await this.$validator.validateAll()
        if (valid) {
            if (this.state.assayLaboratory) {
                if (this._updateMode) {
                    this.update() // emits an event
                } else {
                    this.create() // emits an event
                }
            }

            this.hide()
        }
    }
}
